import styled from '@emotion/styled';

const OptionFormWrapper = styled('form')({
  display: 'flex',
  alignItems: 'center',
});

export default OptionFormWrapper;
